import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/client/Banner";
import CaseStudy from "../components/client/CaseStudy";
import Services from "../components/client/Services";

const Client = () => {
  return (
    <Layout>
      <Banner />
      <CaseStudy />
      <Services />
    </Layout>
  );
};

export default Client;

